import { useEffect } from 'react';
import { useInventoryPageStore } from '../../store/inventoryPage';
import { InventoryFieldWrapper, ChoicesTable } from '../shared';

export function SimpleInventoryChoicesField({
	field,
}: {
	field: GravityFormsField;
}) {
	// Get the choice inventory data directly from the store with a selector function
	const choiceInventories = useInventoryPageStore.use.choiceInventories();
	const { choices, isLoading, error } = choiceInventories[field.id] || {
		choices: {},
		isLoading: false,
		error: null,
	};

	// Fetch choice inventory data when component mounts
	useEffect(() => {
		useInventoryPageStore.getState().fetchChoiceInventory(field.id);
	}, [field.id]);

	// Content to display when not loading or error
	const contentSection =
		field.choices && field.choices.length > 0 ? (
			<ChoicesTable choices={field.choices} inventoryData={choices} />
		) : (
			<div className="inventory-error">
				<p>No choices found for this field.</p>
			</div>
		);

	return (
		<InventoryFieldWrapper
			field={field}
			isLoading={isLoading}
			error={error}
			contentSection={contentSection}
		/>
	);
}
